import { useState } from 'react';
import { TrashCan } from '@carbon/react/icons';
import { Button, ButtonProps } from '@carbon/react';
import { DeleteAtom } from 'atoms/create-resource-atom';
import { useAtom } from 'jotai';
import { DestroyConfirmation } from 'components/destroy-confirmation';

interface Props extends ButtonProps<any> {
  deleteAtom: DeleteAtom;
  onSuccess: () => void;
  onError?: (error: unknown) => void;
  url: string;
  children?: React.ReactNode;
  modalHeading?: string;
}

const DestroyRecordButton = ({
  deleteAtom,
  url,
  onSuccess,
  onError,
  modalHeading,
  children,
  ...rest
}: Props) => {
  const [{ loading }, runDelete] = useAtom(deleteAtom);
  const [showDestroy, setShowDestroy] = useState(false);

  return (
    <>
      <Button
        renderIcon={TrashCan}
        iconDescription={'Delete'}
        tooltipAlignment="end"
        tooltipPosition="top"
        kind="danger--ghost"
        onClick={() => setShowDestroy(true)}
        {...rest}
      >
        {rest.hasIconOnly ? null : 'Delete'}
      </Button>
      <DestroyConfirmation
        open={showDestroy}
        primaryButtonDisabled={loading}
        onRequestClose={() => setShowDestroy(false)}
        modalHeading={modalHeading}
        onRequestSubmit={() => {
          runDelete({
            url,
            onSuccess,
            onError: (error) => {
              setShowDestroy(false);
              onError?.(error);
            },
          });
        }}
      >
        {children}
      </DestroyConfirmation>
    </>
  );
};

export { DestroyRecordButton };
